import moment from 'moment';
import { debounce } from 'lodash';

import { getRequestByReferenceIdApi, listPomRequestsStatusApi } from 'api/orderStatus';
import { orderStatusActions } from 'store/slices/orderStatusSlice';
import { applyFulfillingPharmacyFilter } from 'api/utils';

import { patientActions } from 'store/slices/patientSlice';
import { handleError } from './errorHandlerThunks';

export const loadPrescriptionOrders =
  ({ page }) =>
  (dispatch, getState) => {
    const { preset } = getState().orderStatus;
    const { sortBy, filter } = getState().orderStatus.eScriptOrders;
    const updatedFilter = {
      ...applyFulfillingPharmacyFilter(getState, filter),
      ...(!filter?.createdAt && {
        createdAt: [
          moment().subtract(7, 'days').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD'),
        ],
      }),
    };

    dispatch(orderStatusActions.updateCurrentPage({ preset, page }));

    return listPomRequestsStatusApi({ page, sortBy, filter: updatedFilter })
      .then(({ result, count }) =>
        dispatch(orderStatusActions.loadPrescriptionOrders({ preset, page, items: result, count }))
      )
      .catch((error) => dispatch(handleError({ error })));
  };

export const debouncedLoadPrescriptionOrders = debounce(({ preset, dispatch }) => {
  return dispatch(loadPrescriptionOrders({ page: 1 })).finally(() =>
    dispatch(orderStatusActions.setPrescriptionOrdersLoading({ preset, loading: false }))
  );
}, 1000);

export const updatePrescriptionOrdersFilter =
  ({ filter }) =>
  (dispatch, getState) => {
    const { preset } = getState().orderStatus;
    dispatch(orderStatusActions.setPrescriptionOrdersLoading({ preset, loading: true }));
    dispatch(orderStatusActions.updatePrescriptionOrdersFilter({ preset, filter }));
    debouncedLoadPrescriptionOrders({ preset, dispatch });
  };

export const updatePrescriptionOrdersSortBy =
  ({ sortBy }) =>
  (dispatch, getState) => {
    const { preset } = getState().orderStatus;
    dispatch(orderStatusActions.updatePrescriptionOrdersSortBy({ preset, sortBy }));
    debouncedLoadPrescriptionOrders({ dispatch });
  };

export const loadRequestDetails =
  ({ referenceId, requestId, orderId, fromPatientProfile, mpi, partnerId }) =>
  (dispatch, getState) => {
    const { preset } = getState().orderStatus;
    const { currentPage } = getState().orderStatus[preset];

    return getRequestByReferenceIdApi({ referenceId, requestId, orderId, partnerId })
      .then((requestDetails) => {
        if (fromPatientProfile) {
          return dispatch(patientActions.updateOrder({ orderId, mpi, requestDetails }));
        }

        return dispatch(
          orderStatusActions.updateRequestDetails({
            preset,
            currentPage,
            requestId,
            referenceId,
            requestDetails,
          })
        );
      })
      .catch((error) => dispatch(handleError({ error })));
  };
